import { render, staticRenderFns } from "./BurgerMenuDesktop.vue?vue&type=template&id=6081c075&"
import script from "./BurgerMenuDesktop.vue?vue&type=script&lang=js&"
export * from "./BurgerMenuDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports